import type { TrackerComponentProps } from 'OpalChat/Tracker';
import React from 'react';

/**
 * Host-side lazy loader for the federated Tracker compose icon
 * (`OpalChat/TrackerCompose`). Renders as a pen-to-square button — click
 * opens a To-do / Note picker menu, selection surfaces the inline compose
 * form inside the sibling-mounted `Tracker`. See `LazyTracker` for the
 * parallel-fetch rationale.
 */
const OpalChatTrackerComposePromise: Promise<{
  default: React.ComponentType<TrackerComponentProps>;
}> = import('OpalChat/TrackerCompose')
  .then(m => ({ default: m.TrackerComposeComponent }))
  .catch((error: unknown) => {
    console.error('Failed to load OpalChat TrackerCompose:', error);
    return { default: () => null };
  });

export const LazyTrackerCompose = React.lazy(() => OpalChatTrackerComposePromise);
